import { apiGet } from './http'
import type { PlatformSettingResponse, RawPlatformSetting } from '@/types/api'

/**
 * Typed boundary to the public platform settings (backend-driven switches such
 * as the reassurance screen). Anonymous on purpose: it must answer a prospect
 * who has no session. Transport only — caching and display rules live in
 * `useReassuranceScreen`.
 */

/** Fetch the platform settings (`GET /platform_setting`). */
export async function getPlatformSetting(signal?: AbortSignal): Promise<RawPlatformSetting> {
  const res = await apiGet<PlatformSettingResponse>('/platform_setting', { signal })
  return res.platform_setting
}
